/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const InterfaceChartLine = ({ className, interfaceChartLine = "/img/interface-chart-line-1.png" }) => {
  return <img className={`interface-chart-line ${className}`} alt="Interface chart line" src={interfaceChartLine} />;
};

InterfaceChartLine.propTypes = {
  interfaceChartLine: PropTypes.string,
};
